import { DOMAIN_ACTION } from '@/constants'
import { ICurrentUser } from '@/utils/auth/auth'
import { fetchUserFrontend } from '@/utils/auth/fetchUser'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
import { flow, types } from 'mobx-state-tree'
import { ROOT_STATE_STORAGE_KEY } from '../../setupRootStore'
const axiosAuth = axiosPrivateHelper()

export type UserRole = 'reader' | 'supplier' | 'admin'

interface UserProfileType extends ICurrentUser {
  gender?: string | null
}

export const userProfileModel = types
  .model('UserModel')
  .props({
    id: types.number,
    first_name: types.maybeNull(types.string),
    last_name: types.maybeNull(types.string),
    business_name: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    address: types.maybeNull(types.string),
    image_profile: types.maybeNull(types.string),
    date_of_birth: types.maybeNull(types.string),
    gender: types.optional(types.maybeNull(types.string), null),
    know_us_from: types.maybeNull(types.string),
    phone_number: types.maybeNull(types.string),
    created_at: types.maybeNull(types.string),
    updated_at: types.maybeNull(types.string),
    isVerified: types.maybeNull(types.boolean),
    will_recieve_emails_updates_from_rmw: types.maybeNull(types.boolean),
    stripe_customer_id: types.maybeNull(types.string),
    stripe_subscription_id: types.maybeNull(types.string),
    stripe_checkout_email: types.maybeNull(types.string),
    role: types.maybeNull(types.string),
  })
  .actions((self) => {
    const setProfile = (value: UserProfileType) => {
      self.id = value.id
      self.first_name = value.first_name
      self.last_name = value.last_name
      self.email = value.email
      self.address = value.address
      self.image_profile = value.image_profile
      self.date_of_birth = value.date_of_birth
      self.gender = value.gender || null
      self.know_us_from = value.know_us_from
      self.phone_number = value.phone_number
      self.created_at = value.created_at
      self.updated_at = value.updated_at
      self.role = value.role
      localStorage.setItem(ROOT_STATE_STORAGE_KEY, JSON.stringify(value))
    }

    const submitOnBoard = async (value: any) => {
      const URL = `${DOMAIN_ACTION.API.CUSTOMER_EVENT}/${value.event}`
      const response = await axiosAuth.put(URL, value.payload)
      return response
    }

    const getUserStore = async () => {
      const userStorage = await localStorage.getItem(ROOT_STATE_STORAGE_KEY)
      const userProfile = JSON.parse(userStorage as string)
      return userProfile
    }
    const getCurrentUser = async () => {
      const res = await fetchUserFrontend()
      return await res.json()
    }

    const fetchUser = flow(function* fetchUser(force: boolean = false) {
      if (!force && self.id) return
      const response = yield fetchUserFrontend()
      const userData = yield response.json()
      self = userData
    })

    const setVerifyUser = (value: boolean) => {
      self.isVerified = value
    }

    return {
      setProfile,
      submitOnBoard,
      getUserStore,
      getCurrentUser,
      setVerifyUser,
      fetchUser,
    }
  })
